// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__DSqUa","checkbox":"SuperCheckbox_checkbox__uU9qu","spanClassName":"SuperCheckbox_spanClassName__uCbNG"};